import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import DocumentAPI from '../../api/documents';
import Vue from 'vue';
import {
  DOCUMENT_SOURCES_SORTBY,
  SOURCES_SORT_ORDER,
} from '../../routes/dashboard/sources/constants';
const buildFormData = documentParams => {
  const formData = new FormData();
  delete documentParams.document;
  Object.keys(documentParams).forEach(key => {
    if (documentParams[key]) {
      formData.append(`document[${key}]`, documentParams[key]);
    }
  });
  return formData;
};
export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isDownloading: 0,
  },
  meta: {
    currentPage: 1,
    perPage: 50,
    totalEntries: 0,
    sortOrder: SOURCES_SORT_ORDER.desc,
    sortBy: DOCUMENT_SOURCES_SORTBY.updatedAt,
  },
};

export const getters = {
  getDocuments($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getMeta: $state => {
    return $state.meta;
  },
};

export const actions = {
  get: async ({ commit }, { page, perPage, sortBy, sortOrder }) => {
    commit(types.default.SET_DOCUMENT_SOURCES_FETCHING_STATUS, true);
    try {
      const {
        data: { resources, meta },
      } = await DocumentAPI.get(page, perPage, sortBy, sortOrder);
      commit(types.default.SET_DOCUMENT_SOURCES_FETCHING_STATUS, false);
      commit(types.default.SET_DOCUMENT_SOURCES, resources);
      commit(types.default.SET_DOCUMENT_SOURCES_META, {
        currentPage: meta.current_page,
        perPage: meta.per_page,
        totalEntries: meta.total,
      });
    } catch (error) {
      commit(types.default.SET_DOCUMENT_SOURCES_FETCHING_STATUS, false);
    }
  },
  create: async ({ commit }, { isFormData = false, ...documentParams }) => {
    commit(types.default.SET_DOCUMENT_SOURCES_CREATING_STATUS, true);
    try {
      await DocumentAPI.create(
        isFormData ? buildFormData(documentParams) : documentParams
      );
      actions.refresh({ commit });
      commit(types.default.SET_DOCUMENT_SOURCES_CREATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_DOCUMENT_SOURCES_CREATING_STATUS, false);
      throw error;
    }
  },
  update: async ({ commit }, documentParams) => {
    commit(types.default.SET_DOCUMENT_SOURCES_UPDATING_STATUS, true);
    try {
      await DocumentAPI.update(documentParams.id, {
        document: documentParams
      });
      actions.refresh({ commit });
      commit(types.default.SET_DOCUMENT_SOURCES_UPDATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_DOCUMENT_SOURCES_UPDATING_STATUS, false);
      throw new Error(error);
    }
  },
  delete: async ({ commit }, documentParams) => {
    commit(types.default.SET_DOCUMENT_SOURCES_DELETING_STATUS, true);
    try {
      await DocumentAPI.update(documentParams.id, {
        document: {
          display_name: documentParams.display_name,
          status: 'deleted'
        }
      });
      actions.refresh({ commit });
      commit(types.default.SET_DOCUMENT_SOURCES_DELETING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_DOCUMENT_SOURCES_DELETING_STATUS, false);
      throw new Error(error);
    }
  },
  download: async ({ commit }, documentParams) => {
    try {
      const response = await DocumentAPI.download(documentParams.id);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  refresh: async ({ commit }) => {
    actions.get({ commit }, {
      page: state.meta.currentPage,
      perPage: state.meta.perPage,
    });
  }
};

export const mutations = {
  [types.default.SET_DOCUMENT_SOURCES_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
  [types.default.SET_DOCUMENT_SOURCES_CREATING_STATUS]($state, status) {
    $state.uiFlags.isCreating = status;
  },
  [types.default.SET_DOCUMENT_SOURCES_UPDATING_STATUS]($state, status) {
    $state.uiFlags.isUpdating = status;
  },
  [types.default.SET_DOCUMENT_SOURCES_DELETING_STATUS]($state, status) {
    $state.uiFlags.isDeleting = status;
  },

  [types.default.SET_DOCUMENT_SOURCES]: MutationHelpers.set,
  [types.default.ADD_DOCUMENT_SOURCES]: MutationHelpers.create,
  [types.default.EDIT_DOCUMENT_SOURCES]: MutationHelpers.update,
  [types.default.DELETE_DOCUMENT_SOURCES]: MutationHelpers.destroy,
  [types.default.SET_DOCUMENT_SOURCES_META]: ($state, data) => {
    const { totalEntries, currentPage } = data;
    Vue.set($state.meta, 'totalEntries', totalEntries);
    Vue.set($state.meta, 'currentPage', currentPage);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
